import { Typography } from '@mui/material';
import React from 'react';

type TopSectionProps = {
  children?: React.ReactNode;
  title: string;
  subtitle: string;
};

const TopSection = ({ children, title, subtitle }: TopSectionProps) => {
  return (
    <section className="p-6 md:px-16 md:py-12 rounded-xl bg-paper">
      <div className="flex flex-col gap-4 w-full text-center mb-6">
        <Typography variant="h3" component="h1" color="textPrimary">
          {title}
        </Typography>
        <Typography variant="body-500" component="p" color="textSecondary">
          {subtitle}
        </Typography>
      </div>
      {children}
    </section>
  );
};

export default TopSection;
